export type LatLng = { lat: number; lng: number };

export type PolygonSchema = LatLng[];

export type Polygons = { paths: PolygonSchema }[];

export interface PolygonItemUI {
  id: string;
  paths: PolygonSchema;
  options?: {
    strokeColor?: string;
    strokeOpacity?: number;
    strokeWeight?: number;
    fillColor?: string;
    fillOpacity?: number;
    editable?: boolean;
    draggable?: boolean;
    clickable?: boolean;
  };
}

export interface PolygonFeature {
  id: string;
  name: string;
  paths: LatLng[];
  areaM2: number;
  perimeterM: number;
  source: 'draw' | string;
  updatedAt: string;
}

export interface PolygonsData {
  polygons: PolygonFeature[];
  totalCount: number;
  totalAreaM2: number;
}

export interface PolygonItemPayload {
  name: string;
  paths: LatLng[];
  source?: 'draw' | string;
}

export interface PolygonsPayload {
  polygons: PolygonItemPayload[];
}

export enum GeoParseErrorType {
  EMPTY_GEOJSON = 'EMPTY_GEOJSON',
  INVALID_TYPE = 'INVALID_TYPE',
  INVALID_XML = 'INVALID_XML',
}

export class GeoParseError extends Error {
  constructor(public type: GeoParseErrorType, message?: string) {
    super(message);
    this.name = 'GeoParseError';
  }
}

export type ContextTarget = {
  polyIdx: number;
  ringIdx: number | null;
  vertexIdx: number;
};

export type CityGeo = {
  name: string;
  lat: number;
  lng: number;
  bounds?: {
    northeast: { lat: number; lng: number };
    southwest: { lat: number; lng: number };
  };
  placeId: string;
  rawTypes: string[];
};

export type GeocodeResponse = {
  status: string;
  error_message?: string;
  results: Array<{
    types: string[];
    place_id: string;
    formatted_address: string;
    geometry: {
      location: { lat: number; lng: number };
      bounds?: {
        northeast: { lat: number; lng: number };
        southwest: { lat: number; lng: number };
      };
      viewport?: {
        northeast: { lat: number; lng: number };
        southwest: { lat: number; lng: number };
      };
    };
  }>;
};
